import app, { Component } from 'apprun';
import { serializeObject, companies, locations, users } from './api';
import { isValid, showSaveStatusMessage, validateEmail, lookup_en } from './utils';
import PasswordInput from './password-input';

export default class UserNewComponent extends Component {
  state = {
    brokerageOptions: [],
    locationOptions: [],
    picker: null,
    isAgent: false,
    dispAffilDetail: false,
    availabilityMessage: '',
  };

  view = (state) => {
    if (!state) { return; }
    return <div style={{ width: '400px' }}>
      <form id="userNewForm">
        <div class="list-group">
          <div class="list-group-item">
            Personnel Type: &nbsp;
            <select name="employeeTypeCt" id="employeeTypeCt" oninput={e => this.run('empTypeChanged', e.target.value)} class='pull-right'>
              {lookup_en.EmployeeTypeCt.map(r => <option value={r.id}>{r.value}</option>)}
            </select>
            <div id="companyNameErrMsg" class="text-danger"></div>
          </div>
          <div class="list-group-item">
            Language:
            <select id="language" name="language" class='pull-right'>
              {lookup_en.LangCt.map(r => <option vale={r.id}>{r.value}</option>)}
            </select>
            <div id="languageErrMsg" class="text-danger"></div>
          </div>
          <div class="list-group-item">
            User Name:
            <div>
              <input id="username" name="username" data-validate="NoDomainEmail" />
              @
              <select id="domain" name="domain">
                <option value="royallepage.ca">royallepage.ca</option>
                <option value="johnstonanddaniel.com">johnstonanddaniel.com</option>
                <option value="royallepagecommercial.com">royallepagecommercial.com</option>
              </select>
            </div>
            <div id="usernameErrMsg" class="text-danger"></div>
            <a href="" onclick={() => this.run('checkAvailability')}><i class="fa fa-eye mr1" />&nbsp;Check Availability</a>
            <div class="text-danger"> {state.availabilityMessage} </div>
          </div>
          <div class="list-group-item">
            Select Password: <PasswordInput id="password" name="password" class='pull-right' />
            <div id="passwordErrMsg" class="text-danger"></div>
          </div>
          <div class="list-group-item">
            First Name: <input id="firstName" name="firstName" class='pull-right' data-validate />
            <div id="firstNameErrMsg" class="text-danger"></div>
          </div>
          <div class="list-group-item">
            Last Name: <input id="lastName" name="lastName" class='pull-right' data-validate />
            <div id="lastNameErrMsg" class="text-danger"></div>
          </div>
          {
            state.isAgent
              ?
              <div class="list-group-item" style={{ 'display': state.isAgent ? 'block' : 'none' }}>
                Name on Tag: <input id="displayNameOnTag" name="displayNameOnTag" data-validate class='pull-right' />
                <div id="displayNameOnTagErrMsg" class="text-danger"></div>
              </div>
              :
              <div/>
          }
          <div class="list-group-item" >
            Title:
            <select name="title" id="title" required="required" data-validate="Int-1" style={{ 'width': '200px' }} class='pull-right'>
              <option value="-1">[Select]</option>
              {lookup_en.Title.map(r => <option value={r.id}>{r.value}</option>)}
            </select>
            <div id="titleErrMsg" class="text-danger"></div>
          </div>

          <div class="list-group-item">
            Company:
            <select id="companyID" name="brokerage" data-validate="Int" oninput={e => this.run('companySelectionChanged', e.target.value)} style={{ 'width': '300px' }} class='pull-right'>
              <option value="0">[Select]</option>
              {state.brokerageOptions.map(r =>
                (<option value={r.id} selected={r.id === state.companyId ? 'selected' : null}>{r.id + ' - ' + r.name}</option>)
              )}
            </select>
            <div id="companyIDErrMsg" class="text-danger" />
          </div>
          <div class="list-group-item">
            Location:
            <select id="locationID" name="location" style={{ 'width': '300px' }} data-validate="Int" class='pull-right'>
              {state.companyId === 0 ? <option value="0">Select Company First</option> : <option value="0">[Select]</option>}
              {state.locationOptions.map(r =>
                (<option value={r.id}>{r.id + ' - ' + r.name}</option>)
              )}
            </select>
            <div id="locationIDErrMsg" class="text-danger" />
          </div>
          {
            state.isAgent
              ?
              <div class="list-group-item">
                Sales Kit Required:
                <select id="salesKitRequired" name="salesKitRequired" required="required" data-validate="Int-1" class='pull-right'>
                  {lookup_en.ReceiveSalesKitRequest.map(r => <option value={r.id}>{r.value === 'e' ? 'English' : r.value === 'f' ? 'French' : r.value === 'n' ? 'No' : ''}</option>)}
                </select>
                <div id="salesKitRequiredErrMsg" class="text-danger"></div>
              </div>
              :
              null
          }
          <div class="list-group-item" >
            Recruitment Source:
            <select name="recruitmentSource" id="recruitmentSource" required="required" data-validate="Int-1" style={{ 'width': '200px' }} class='pull-right'>
              {lookup_en.RecruitmentSource.map(r => <option value={r.id}>{r.value}</option>)}
            </select>
            <div id="recruitmentSourceErrMsg" class="text-danger"></div>
          </div>
          <div class="list-group-item" >
            Previous Affiliation:
            <select name="previousAffiliation" id="previousAffiliation" required="required" data-validate="Int-1" oninput={e => this.run('prevAffiliationChanged', e.target.value)} style={{ 'width': '200px' }} class='pull-right'>
              {lookup_en.PreviousAffiliation.map(r => <option value={r.id}>{r.value}</option>)}
            </select>
            <div id="previousAffiliationErrMsg" class="text-danger"></div>
          </div>
          {
            state.dispAffilDetail
              ?
              <div class="list-group-item" style={{ 'display': state.dispAffilDetail ? 'disp' : 'none' }} >
                Previous Affiliation details: <input id="previousAffiliationDetails" name="previousAffiliationDetails" class='pull-right' />
                <div id="previousAffiliationDetailsErrMsg" class="text-danger"></div>
              </div>
              :
              null
          }
          <input style={{ 'display': 'none' }} /><input style={{ 'display': 'none' }} />
          <div class="list-group-item">
            Start Date: <input $pikaday id="startDate" name="activationDate" class='pull-right' placeholder="DD-MMM-YYYY" data-validate="Date" autocomplete="off" />
            <div id="startDateErrMsg" class="text-danger"></div>
          </div>
        </div>
      </form>
      <div class="edit-buttons">
        <button class="btn btn-default btn-xs pull-right" onclick={() => this.run('cancel')}>cancel</button>&nbsp;
        <button class="btn btn-primary btn-xs pull-right" onclick={() => this.run('save')} >Save</button>
      </div>
    </div>;
  }

  update = {
    refresh: async (state, companyId) => {
      state.companyId = companyId ? companyId : 0;
      if (state.brokerageOptions.length === 0) {
        state.brokerageOptions = await companies.getOpenCompanies();
      }
      this.run('companySelectionChanged', state.companyId);
      return state;
    },

    empTypeChanged: (state, idx) => {
      const isAgent = idx === '1' || idx === '8';
      if (isAgent !== state.isAgent) { state.picker = null; }
      return { ...state, isAgent };
    },

    prevAffiliationChanged: (state, idx) => {
      //console.log('in prevAffiliationChanged ...');
      const dispAffilDetail = idx === '354';
      if (dispAffilDetail !== state.dispAffilDetail) { state.picker = null; }
      return { ...state, dispAffilDetail };
    },

    companySelectionChanged: async (state, idx) => {
      state.companyId = idx;
      state.locationOptions = state.companyId === 0 ? [] : await locations.getLocationsByCompanyID(state.companyId);
      return state;
    },

    checkAvailability: async (state) => {
      const userName = (document.getElementById('username') as HTMLInputElement).value.trim();
      const userDomain = (document.getElementById('domain') as HTMLInputElement).value.trim();

      if (userName.length === 0) {
        state.availabilityMessage = 'Please provide Username';
      } else if (!validateEmail(userName + '@royallepage.ca')) {
        state.availabilityMessage = 'Invalid Username';
      } else {
        const emailAddress = userName + '@' + userDomain;
        const result = await users.checkEmailAvailability(emailAddress);
        state.availabilityMessage = emailAddress + ' is ' + (result ? 'available' : 'unavailable');
      }

      return state;
    },

    save: async (state) => {
      try {
        const formName = 'userNewForm';

        if (!isValid(formName)) { return; }
        const formData = serializeObject(document.getElementById(formName));
        formData['location'] = { id: formData['location'] };

        const emailAddress = formData['username'] + '@' + formData['domain'];
        const isAvailable = await users.checkEmailAvailability(emailAddress);
        if (isAvailable) {
          const result = await users.Post(formData);
          showSaveStatusMessage('user');
          app.run('#user', result.id, result.lastName + ', ' + result.firstName);
        } else {
          state.availabilityMessage = emailAddress + ' is unavailable';
        }
      } catch {
        showSaveStatusMessage();
      }
    },
    cancel: (state) => {
      app.run('#clear-panel', state.panelId);
    },
  };

  mounted = ({ state }) => {
    this.run('refresh', state.companyId);
  };
}
